import {ThemeColors} from "@/src/entities/colors";

export class ThemeService {
    private static instance: ThemeService

    private constructor() {
        if (ThemeService.instance) {
            throw new Error("Error: Instantiation failed: Use ThemeService.getInstance() instead of new.");
        }
        ThemeService.instance = this;
    }

    static getInstance(): ThemeService {
        ThemeService.instance = ThemeService.instance || new ThemeService();
        return ThemeService.instance;
    }

    static getThemeColors(): ThemeColors {
        return {
            primary: "#000",
            secondary: "#CCC",
            tertiary: "#FFF",
            menuBarColor: "#5c9f24",
            containersBackgroundOdd: "#fafafa",
            containersBackgroundEven: "#fff"
        }
    }
}